// extracted by mini-css-extract-plugin
export default {"action_data":"GrowthHabit_action_data__GYa99","textAction":"GrowthHabit_textAction__6GK5y","action_box":"GrowthHabit_action_box__JJzer"};